import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { AccountClientService } from '@automatick/shared-client-ng';
import { ApiModule, Configuration } from '@automatick/shared-ng';
import { ACCOUNT_SERVICE_TOKEN, AuthNgModule } from '@seech/auth-ng';
import { ControlsNgModule } from '@seech/controls-ng';
import {
  CoreNgModule,
  StorageService as CoreStorageService,
} from '@seech/core-ng';
import { PaymentNgModule } from '@seech/payment-ng/providers';
import { UxNgModule } from '@seech/ux-ng';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import {
  APP_TELEMETRY_CONFIG,
  APP_TELEMETRY_TRANSPORT,
  AppConsoleTelemetryTransport,
  CurrentDeviceContextInterceptor,
  GlobalErrorHandler,
} from './services';
import { WEB_STORAGE } from './services/token';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      HttpClientModule,
      UxNgModule,
      CoreNgModule.forRoot({
        BASE_API_URL: environment.BASE_API_URL,
        REALTIME_HUB_URL: environment.REALTIME_HUB_URL,
        GOOGLE_ANALYTICS_ID: environment.GOOGLE_ANALYTICS_ID,
        GOOGLE_API_KEY: environment.GOOGLE_API_KEY,
      }),
      ControlsNgModule.forRoot({
        googleAPIKey: environment.GOOGLE_API_KEY,
      }),
      AuthNgModule.forRoot({
        AUTH_API_URL: environment.AUTH_API_URL,
        AUTH_WEB_URL: environment.AUTH_WEB_URL,
        BASE_API_URL: environment.BASE_API_URL,
        CLIENT_ID: environment.CLIENT_ID,
        SESSION_TIMEOUT: environment.SESSION_TIMEOUT,
      }),
      PaymentNgModule.forRoot({
        apiBaseUrl: environment.PAYMENT_API_URL,
        stripePublishableKey: environment.STRIPE_PUBLIC_KEY,
        enabledPaymentMethods: ['virtual-card', 'bank-card'],
      }),
      ApiModule.forRoot(() => new Configuration({ basePath: '' })),
    ),
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    // Interceptors are registered by Seech modules (core/auth/ux).
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    {
      provide: APP_TELEMETRY_CONFIG,
      useValue: Object.freeze({ enabled: !environment.production }),
    },
    {
      provide: APP_TELEMETRY_TRANSPORT,
      useFactory: () =>
        environment.production ? null : new AppConsoleTelemetryTransport(),
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CurrentDeviceContextInterceptor,
      multi: true,
    },
    { provide: WEB_STORAGE, useExisting: CoreStorageService },
    { provide: ACCOUNT_SERVICE_TOKEN, useClass: AccountClientService },
  ],
};
